module.exports = __webpack_public_path__ + "img/image11.5dc8d616.jpg";